/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
// import Link from "@insite/mobius/Link"; // Poolcorp Custom Code
// import Typography from "@insite/mobius/Typography"; // Poolcorp Custom Code
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
// import styled, { css } from "styled-components"; // Poolcorp Custom Code

/* Poolcorp Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { clearfixStyles, contentSpacingStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import styled, { css } from "styled-components";

/* Poolcorp Custom Code */

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

/* Poolcorp Custom Code */
export interface CardListHeadingPresentationProps {
    itemSpacing?: string;
}

export interface CardListHeadingProps extends OwnProps, CardListHeadingPresentationProps {}

export interface CardListHeadingStyles {
    container?: InjectableCss;
    wrapper?: InjectableCss<CardListHeadingPresentationProps>;
    wrapperItem?: InjectableCss<CardListHeadingPresentationProps>;
    title?: TypographyProps;
    link?: LinkPresentationProps;
}

const Wrapper = styled(StyledWrapper)<CardListHeadingPresentationProps>``;

const styles: CardListHeadingStyles = {
    container: {
        css: css`
            ${clearfixStyles()}
            ${contentSpacingStyles(null, TYPOGRAPHY.spacing.base)}
            line-height: ${TYPOGRAPHY.lineHeight.small};
        `,
    },
    wrapper: {
        css: css<CardListHeadingPresentationProps>`
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            justify-content: space-between;
            ${({ itemSpacing }) => (itemSpacing ? `margin-top: -${itemSpacing};` : null)}
        `,
    },
    wrapperItem: {
        css: css<CardListHeadingPresentationProps>`
            display: flex;
            margin-right: 1em;
            ${({ itemSpacing }) => (itemSpacing ? `margin-top: ${itemSpacing};` : null)}

            &:last-child {
                margin-right: 0;
            }
        `,
    },
    title: {
        variant: "h4",
        as: "h2",
    },
    link: {
        css: css`
            ${getProp("theme.link.defaultProps.css")}
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
};

export const cardListHeadingStyles = styles;

const CardListHeading: React.FunctionComponent<CardListHeadingProps> = ({
    children,
    heading,
    viewAllUrl,
    itemSpacing,
}) => {
    const presentationProps = {
        itemSpacing: itemSpacing ?? "0.4em",
    };

    return (
        <Wrapper {...styles.container} {...presentationProps}>
            <Wrapper {...styles.wrapper} {...presentationProps}>
                <Wrapper {...styles.wrapperItem} {...presentationProps}>
                    <Typography {...styles.title} className="card-list-heading">{heading}</Typography>
                </Wrapper>
                <Wrapper {...styles.wrapperItem} {...presentationProps}>
                    {children}
                    {!children && viewAllUrl && (
                        <Link
                            href={viewAllUrl}
                            {...styles.link} 
                            className="view-all-link"
                            data-test-selector="cardListHeadingViewAllLink"
                        >
                            {translate("View All")}
                            <VisuallyHidden>
                                {translate("View All")} {heading}
                            </VisuallyHidden>
                        </Link>
                    )}
                </Wrapper>
            </Wrapper>
        </Wrapper>
    );
};
/* Poolcorp Custom Code */

export default CardListHeading;
